/**
 * A senha de uma sala, como os DOIS lados a entendem.
 *
 * Fica no protocolo porque servidor e cliente precisam concordar no que é uma
 * senha aceitável antes de qualquer hash: o cliente recusa cedo, com a frase
 * certa, e o servidor recusa de novo, porque não confia no cliente. Se cada
 * um tivesse os seus limites, uma senha aceita na tela cairia no servidor com
 * um erro que a tela não sabe explicar.
 *
 * O que NÃO está aqui, de propósito: hash e comparação. Isso é do servidor, e
 * só dele — a senha em claro nunca é guardada, nem lá nem no cliente.
 */

export const ROOM_PASSWORD_MIN = 4
export const ROOM_PASSWORD_MAX = 32

/**
 * A forma canônica de uma senha, antes de qualquer conferência.
 *
 * Espaços nas pontas fora (colar de um chat traz um) e NFC, para "é" digitado
 * num teclado e "é" composto noutro serem a mesma senha. Espaços NO MEIO
 * ficam: são parte da frase que o criador escolheu.
 */
export const normalizarSenha = (texto: string): string => texto.trim().normalize('NFC')

export type SenhaRecusa = 'curta' | 'longa'

/**
 * A senha normalizada, ou por que não serve. `null` para o texto vazio, que
 * não é senha nem erro: é "sem senha".
 */
export function conferirSenha(texto: string): { ok: true; senha: string } | { ok: false; motivo: SenhaRecusa } | null {
  const senha = normalizarSenha(texto)
  if (senha.length === 0) return null
  // `length` conta code units; um emoji vale dois. O limite é de guarda, não
  // de precisão, então isso não importa — e é o mesmo dos dois lados.
  if (senha.length < ROOM_PASSWORD_MIN) return { ok: false, motivo: 'curta' }
  if (senha.length > ROOM_PASSWORD_MAX) return { ok: false, motivo: 'longa' }
  return { ok: true, senha }
}
